<script lang="ts">
    import DateInput from './DateInput.svelte';
    import NumberInput from './NumberInput.svelte';
    import TextInput from './TextInput.svelte';
    import SelectInput from './SelectInput.svelte';
    import TextField from './TextField.svelte';
    import Zones from './Zones.svelte';
    import {getNewerDate, isNewerThen, getMonths, formatValue, formatDate, isSame} from './utils';
    import {
        getCosts,
        getCostsWithRecalculation,
        getAvgMonthMileage,
        getExpectedMileage,
        getDiffMileage,
        getRecalculate,
        getContractExpiredNew
    } from './service';
    import {DiffMileageUnit, FutureMileageCalcMode, RecalculateOption} from './enums';

    //model input
    let maxMileage: number = null;
    let diffMileageUnit: DiffMileageUnit = DiffMileageUnit.Percent;
    let diffMileagePercent: number = null;
    let diffMileageKm: number = null;
    let rz: string = '';
    let lessor: string = '';
    let monthlyRent: number = null;
    let contractValidFrom: string = ''; //new Date().toISOString().substring(0, 10); //YYYY-MM-DD
    let contractExpired: string = ''; //new Date().toISOString().substring(0, 10); //YYYY-MM-DD
    let contractedMileage: number = null;
    let currentMileage: number = null;
    let currentMileageDate: string = ''; //new Date().toISOString().substring(0, 10); //YYYY-MM-DD
    let futureMileageCalcMode: FutureMileageCalcMode = FutureMileageCalcMode.Computed;
    let customAvgMonthlyMileage: number = null;
    let surchargeOrReturnSum;

    let monthlyRentNew: number = null;
    let recalculateFrom: string = '' //YYYY-MM-DD
    //let contractExpiredNew: string = '2021-10-09' //YYYY-MM-DD
    let contractedMileageNew: number = null;
    let monthlyRentNewCar: number = null;

    //model vypoctene
    $: avgMonthlyMileage = getAvgMonthMileage(currentMileage, contractValidFrom, currentMileageDate);
    $: contractRemainingMonths = getMonths(currentMileageDate, contractExpired);
    $: expectedMileage =
            futureMileageCalcMode === FutureMileageCalcMode.Computed ?
                getExpectedMileage(currentMileage, avgMonthlyMileage, contractRemainingMonths) :
                getExpectedMileage(currentMileage, customAvgMonthlyMileage, contractRemainingMonths);
    $: computedDiffMileage = getDiffMileage(expectedMileage, contractedMileage);
    $: computedDiffMileagePercent = computedDiffMileage / contractedMileage;
    $: recalculateState = diffMileageUnit === DiffMileageUnit.Km ? 
            getRecalculate(maxMileage, expectedMileage, computedDiffMileage, diffMileageKm) :
            getRecalculate(maxMileage, expectedMileage, computedDiffMileagePercent, diffMileagePercent/100);
    $: isSurcharge = computedDiffMileage > 0;
    $: contractRemainingMonthsNew = getMonths(recalculateFrom, contractExpiredNew);
    $: costsWithRecalculation = getCostsWithRecalculation(recalculateFrom, monthlyRentNew, contractExpired, contractExpiredNew, monthlyRentNewCar);
    $: costs = getCosts(contractExpired, contractExpiredNew, recalculateFrom, monthlyRent, surchargeOrReturnSum, monthlyRentNewCar);
    $: savings = Math.abs(costsWithRecalculation - costs);
    $: contractExpiredNew = futureMileageCalcMode === FutureMileageCalcMode.Computed ? 
        getContractExpiredNew(recalculateState, contractExpired, maxMileage, currentMileage, avgMonthlyMileage, currentMileageDate) :
        getContractExpiredNew(recalculateState, contractExpired, maxMileage, currentMileage, customAvgMonthlyMileage, currentMileageDate);
</script>

<div class="container">
    

    <div class="row section">
        <div class="col-md-12">
            <div class="wrapper">
            <h2>1. Zadejte stávající hodnoty z nájemní smlouvy</h2>

            <TextInput inline bind:value={rz} id="rz" label="RZ" />
            
            <TextInput inline bind:value={lessor} id="lessor" label="Pronajímatel" />
            
            <NumberInput inline bind:value={monthlyRent} id="monthlyRent" label="Měsíční nájemné bez DPH" suffix="Kč" precision={2} />
            
            <DateInput inline bind:value={contractValidFrom} id="contractValidFrom" label="Datum začátku smlouvy" />
            
            <DateInput inline bind:value={contractExpired} id="contractExpired" label="Datum konce smlouvy" />
            
            <NumberInput inline bind:value={contractedMileage} id="contractedMileage" label="Smluvený nájezd" suffix="km" />

            </div>
        </div>
    </div>

    <div class="row section">
        <div class="col-sm-12">
            <div class="wrapper">
            <h2>2. Zadejte parametry pro rekalkulaci a aktuální nájezd vozidla</h2>

            <NumberInput inline bind:value={maxMileage} suffix="km" id="maxMileage" label="Maximální povolený nájezd" helperText="Maximální hodnota nájezdu vozidla určená Vaší Car policy nebo limitem od leasingové společnosti."/>

            <SelectInput inline id="diffMileageUnit" label="Rekalkulovat při rozdílu v" helperText="Vyberte, zdali bude rozdíl v nájezdech počítán v km nebo % z celkového nájezdu" bind:value={diffMileageUnit}>
                <option value={DiffMileageUnit.Km}>{DiffMileageUnit.Km}</option>
                <option value={DiffMileageUnit.Percent}>{DiffMileageUnit.Percent}</option>
            </SelectInput>

            {#if diffMileageUnit === DiffMileageUnit.Km}
                <NumberInput inline bind:value={diffMileageKm} id="diffMileageKm" label="Akceptovatelný rozdíl v nájezdech" suffix="km" />
            {:else if diffMileageUnit === DiffMileageUnit.Percent}
                <NumberInput inline bind:value={diffMileagePercent} id="diffMileagePercent" label="Akceptovatelný rozdíl v nájezdech" suffix="%" precision={2} />
            {/if}

            <NumberInput inline bind:value={currentMileage} id="currentMileage" label="Aktuální nájezd vozidla" suffix="km" />
            
            <DateInput inline bind:value={currentMileageDate} id="currentMileageDate" label="Nájezd k datu" />
            </div>
        </div>
    </div>

    
    <div class="row section">

        <div class="col-sm-12">
            <div class="wrapper">
            <h2>3. Výpočítejte budoucí nájezdy vozidla</h2>

            <SelectInput inline id="futureMileageCalcMode" label="Pro výpočet budoucích nájezdů použít hodnotu" helperText="Vyberte, jestli chcete pro výpočet budoucích nájezdů použít průměrnou hodnotu z aktuálního nájezdu nebo vlastní hodnotu." bind:value={futureMileageCalcMode}>
                <option value={FutureMileageCalcMode.Computed}>{FutureMileageCalcMode.Computed}</option>
                <option value={FutureMileageCalcMode.Custom}>{FutureMileageCalcMode.Custom}</option>
            </SelectInput>

            {#if futureMileageCalcMode === FutureMileageCalcMode.Computed}
                <TextField inline label="Průměrné měsíční nájezdy celkem:">
                    {formatValue(avgMonthlyMileage, 0, 'km')}
                </TextField>
            {:else if futureMileageCalcMode === FutureMileageCalcMode.Custom}
                <NumberInput inline bind:value={customAvgMonthlyMileage} id="customAvgMonthlyMileage" label="Vlastní průměrné měsíční nájezdy" suffix="km" />
            {/if}

            <TextField inline label="Zbývá do konce smlouvy:">
                {formatValue(contractRemainingMonths, 2)} měsíců
            </TextField>
            
            <TextField inline label="Předpokládaný nájezd:">
                {formatValue(expectedMileage, 0, 'km')}
            </TextField>
            
            <TextField inline label="Rozdíl v nájezdech:">
                {formatValue(computedDiffMileage, 0, 'km')}
            </TextField>
            
            <TextField inline label="Rozdíl v nájezdech v %:">
                {formatValue(computedDiffMileagePercent * 100, 1, '%')}
            </TextField>

            <TextField inline label="Požádat o návrh rekalkulace:">
                {#if recalculateState === RecalculateOption.Yes || recalculateState === RecalculateOption.YesMaxMileage}
                    <span class="recalculate-state yes">
                        {recalculateState}
                        {#if recalculateState === RecalculateOption.Yes}
                        {#if contractedMileage > expectedMileage}
                            - z důvodu nižších nájezdů
                        {:else if contractedMileage < expectedMileage}
                            - z důvodu vyšších nájezdů
                        {:else}
                            &nbsp;
                        {/if}
                        {/if}
                    </span>
                {:else}
                    <span class="recalculate-state no">
                        {recalculateState}
                    </span>
                {/if}
            </TextField>

            
            </div>
        </div>
    </div>
    
    {#if recalculateState === RecalculateOption.Yes || recalculateState === RecalculateOption.YesMaxMileage}
    <div class="row section">
        <div class="col-sm-12">
            <div class="wrapper">
            <h2>4. Požádejte leasingovou společnost o návrh rekalkulace s těmito údaji</h2>

            <TextField label="Varianta rekalkulace:">
                {#if isNewerThen(contractExpired, contractExpiredNew)}
                    Zkrácení doby nájmu
                {:else if isNewerThen(contractExpiredNew, contractExpired)}
                    Prodloužení doby nájmu
                {:else}
                    Doba nájmu zůstává stejná
                {/if}
                a
                {#if contractedMileage > expectedMileage}
                    snížení nájezdu
                {:else if contractedMileage < expectedMileage}
                    zvýšení nájezdu
                {:else}
                    nájezd zůstává stejný
                {/if}
            </TextField>

            {#if recalculateState === RecalculateOption.Yes}
                <TextField label="Parametry rekalkulace:">
                    <div>
                        <strong>Nájezd:</strong> {formatValue(expectedMileage, 0, 'km')}, <strong>Datum konce smlouvy:</strong> {formatDate(contractExpired)}, <strong> Od začátku smlouvy:</strong> {formatValue(getMonths(contractValidFrom, contractExpired), 2)} měsíců
                    </div>
                </TextField>
                {:else if recalculateState === RecalculateOption.YesMaxMileage}
                <TextField label="Parametry rekalkulace:">
                    <div>
                        <strong>Nájezd:</strong> {formatValue(maxMileage, 0, 'km')}, <strong>Datum konce smlouvy:</strong> {formatDate(contractExpiredNew)}, <strong> Od začátku smlouvy:</strong> {formatValue(getMonths(contractValidFrom, contractExpiredNew), 2)} měsíců
                    </div>
                </TextField>
                {/if}
            </div>
        </div>
    </div>


    <div class="row section">
        <div class="col-sm-12">
            <div class="wrapper">
            <h2>5. Zadejte hodnoty rekalkulace získané od leasingové společnosti a ověřte její výhodnost</h2>

            <Zones
                defaultFinishedKmTo={[3000]}
                defaultFinishedKmPrice={[0]}
                isSurcharge={isSurcharge}
                computedDiffMileage={computedDiffMileage}
                bind:sum={surchargeOrReturnSum}
            />

            <NumberInput inline bind:value={monthlyRentNew} id="monthlyRentNew" label="Měsíční nájemné bez DPH" suffix="Kč" />
            
            <DateInput inline bind:value={recalculateFrom} id="recalculateFrom" label="Rekalkulace od data" />
            
            <DateInput inline bind:value={contractExpiredNew} id="contractExpiredNew" label="Datum konce smlouvy" />
            
            <NumberInput inline bind:value={contractedMileageNew} id="contractedMileageNew" label="Smluvený nájezd" suffix="km" />

            <TextField inline label="Zbývá do konce smlouvy:">
                {formatValue(contractRemainingMonthsNew, 2)} měsíců
            </TextField>

            {#if !isSame(contractExpired, contractExpiredNew)}
                <NumberInput inline bind:value={monthlyRentNewCar} id="monthlyRentNewCar" label="Měsíční nájemné - nové vozidlo" helperText="Výše nájmu za nové vozidlo se stejným nájezdem, jaký je použit pro rekalkulaci stávajícího vozidla." suffix="Kč" />
            {/if}

            <TextField inline label="Výpočet nákladů do:">
                {formatDate(getNewerDate(contractExpired, contractExpiredNew))}
            </TextField>
            
            <TextField inline label="Náklady s rekalkulací:">
                {formatValue(costsWithRecalculation, 0, 'Kč')}
            </TextField>
            
            <TextField inline label="Náklady bez rekalkulace:">
                {formatValue(costs, 0, 'Kč')}
            </TextField>
            
            <TextField inline label="Doporučení:" customClass="bold">
                {#if costsWithRecalculation > costs}
                    <span class="recommendation no">
                        NEREKALKULOVAT
                    </span>
                {:else}
                    <span class="recommendation yes">
                        REKALKULOVAT
                    </span>
                {/if}
            </TextField>
            
            <TextField inline label="Celková úspora:" customClass="bold">
                <span class="recommendation">
                    {formatValue(savings, 0, 'Kč')}
                </span>
                
            </TextField>
            </div>
        </div>
    </div> 
    {:else}
           &nbsp;         
    {/if}

    <div class="row section">
        <div class="col-sm-12 text-center">
            <h3>Rádi byste tuto kalkulačku použili na celý Váš vozový park? Kontaktujte nás na <a href="mailto:fleetmanagement@azmobility.cz">fleetmanagement@azmobility.cz</a></h3>
        </div>
    </div>

    
        
    </div>
